export default function formatMessageContentSwiperList ({
    data: swiperList/* ,
    guide_text,
    mode */
}) {
    return {
        swiperList: swiperList.map(swiperItem => {
            return {
                name: swiperItem.name,
                qids: swiperItem.qids,
                options: swiperItem.recommends.map(item => {
                    return {
                        text: item
                    }
                })
            }
        })
    }
}
